import { render } from "./DocumentTaggingRework.vue?vue&type=template&id=1e91de87&scoped=true"
import script from "./DocumentTaggingRework.vue?vue&type=script&lang=js"
export * from "./DocumentTaggingRework.vue?vue&type=script&lang=js"

import "./DocumentTaggingRework.vue?vue&type=style&index=0&id=1e91de87&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e91de87"]])

export default __exports__